import type { FaireProductEntity } from "../../entity_types/product";

export const p_aryz42c: FaireProductEntity = {
  token: "p_aryz42c",
  type: "product",
  name: "Premium Trail Mix",
  brandName: "Prospect Park Provisions",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/4fb0053c038da43fea88453879e5f7e47e6d704d2187387bf9068de4ddabb984.webp",
  priceDollars: 15,
  description: "Organic trail mix with cashews, almonds, and dried cranberries",
  categoryTokens: ["cat_food-snacks"],
  tags: ["nyc-local", "premium", "organic", "healthy"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/4fb0053c038da43fea88453879e5f7e47e6d704d2187387bf9068de4ddabb984.webp",
  weight: 0.8,
  dimensions: {
    width: 4,
    height: 7,
    depth: 2,
  },
  inStock: true,
};
